export default "__VITE_ASSET__DNf4DSkI__"